<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      addText=""
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
            <!-- <label>商品:</label>
            <lk-input clearable v-model='query.nameMix' class="item" placeholder="商品名称、通用名称、助记码、商品编码"></lk-input> -->
          </div>
          <div class="queryItem">
            <label>采购计划单号:</label>
            <lk-input clearable v-model='query.code' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
            <lk-select v-model='query.goodsType' class="item" clearable>
              <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker  v-model='query.createTimeStart' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker  v-model='query.createTimeEnd' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>审批状态:</label>
            <lk-select v-model='query.status' class="item">
              <lk-option v-for="(item, index) in type" :key="index" :value="index+1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>创建人:</label>
            <lk-input clearable v-model='query.createUserName' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>物流类型:</label>
            <lk-select v-model='query.expressType' class="item" filterable clearable>
              <lk-option v-for="(item, index) in expressList" :key="index" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div v-if="showAdd" class="btn-wrap">
          <lk-button type="primary" @click="addNew">+新增采购计划</lk-button>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import expressTypeList from '../../libs/sharedDara'

export default {
  name: 'planList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {
    // getNormalGoodsTypes() {
    //   return this.$store.state.publicParams.goodsTypes;
    // },
    ...mapGetters(['getNormalGoodsTypes', 'getGoodsOrigin']),
  },
  data() {
    return {
      showAdd: false,
      showEdit: false,
      expressList:[],
      query: {
        code: '',
        status: '',
        createUserName: '',
        createTimeStart: null,
        createTimeEnd: null,
        nameMix: '',
        purchaseType: null,
        expressType: '',
        goodsType: null, // 商品类型
      },
      columns: [
        {
          title: '采购计划单号', key: 'code', fixed: 'left', width: 180, tooltip: true,
        },
        {
          title: '商品类型', key: 'goodsTypeName', width: 180, tooltip: true,
        },
        {
          title: '来源', key: 'typeName', width: 180, tooltip: true,
        },
        {
          title: '采购形式', key: 'procurementFormName', width: 180, tooltip: true,
        },
        { title: '审批状态', key: 'statusName', minWidth: 180, tooltip: true },
        { title: '创建人', key: 'createUserName', minWidth: 180, tooltip: true },
        { title: '创建时间', key: 'createTime', minWidth: 180, tooltip: true },
        { title: '物流类型', key: 'expressTypeName', minWidth: 180, tooltip: true },
        {
          title: '操作',
          key: 'operation',
          minWidth: 180,
          render: (h, params) => {
            let disabled = false;
            if (params.row.status === 2 || params.row.status === 3) {
              disabled = true;
            }
            if (this.showEdit) {
              const editButton = disabled ? h('div') : h('lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                  disabled,
                },
                on: {
                  click: () => {
                    this.$router.push({ name: 'planEdit', params: { purchasePlanId: params.row.id, storeId: params.row.storeId } });
                  },
                },
              }, '编辑');
              return h('div', [

                h('lk-button', {
                  props: {
                    type: 'text',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.$router.push({ name: 'planDetail', params: { purchasePlanId: params.row.id, storeId: params.row.storeId } });
                    },
                  },
                }, '查看'),
                editButton,
              ]);
            }
            return h('div', [
              h('lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.$router.push({ name: 'planDetail', params: { purchasePlanId: params.row.id, storeId: params.row.storeId } });
                  },
                },
              }, '查看'),
            ]);
          },
        },
      ],
      tableData: [],
      selection: [],
      type: ['草稿', '审核中', '审核通过', '审核未通过'],
    };
  },
  methods: {
    onDelete() {
      let ids = [];
      ids = this.selection.map(item => item.id);
      if (ids.length <= 0) {
        return;
      }
      const data = {
        purchasePlanIds: ids,
      };
      purchase.planDelete(data).then(() => {
        this.getData();
      });
    },
    clear() {
      this.query = {
        // code: '',
        // status: '',
        // createUserName: '',
        // createTimeStart: '',
        // createTimeEnd: '',
        // storeIdList: [],
        // goodsType: '',
        // purchaseType: 1,
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // if (this.params.createTimeStart) {
      //   this.params.createTimeStart = (new Date(this.params.createTimeStart)).getTime();
      // }
      // if (this.params.createTimeEnd) {
      //   this.params.createTimeEnd = (new Date(this.params.createTimeEnd)).getTime();
      // }

      purchase.planList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = utils.formatTime(result.createTime, 'YYYY/MM/DD HH:mm');
            result.statusName = this.type[result.status - 1];
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew(type) {
      this.$router.push({ name: 'planAdd', query: { type } });
    },
  },
  mounted() {
    this.expressList = expressTypeList.expressTypeList;
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, {
        title: '门店名称', key: 'storeName', minWidth: 116, tooltip: true,
      });
    }
    this.handleSearch(true);
    if (this.handlePermission('planAdd')) {
      this.showAdd = true;
    }
    if (this.handlePermission('planEdit')) {
      this.showEdit = true;
    }
  },
};
</script>
<style lang="less" scoped>
.plan-list{
  .query-item{
    display: flex;
    align-items: center;
    .query-label{
      margin-right: 10px;
    }
  }
  .search-btn{
    margin-right: 10px;
  }
  .query-params-wrap{
    padding-bottom: 20px;
  }
  .btn-wrap{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;
    >.ivu-btn{
      margin-right: 16px;
    }
  }
}
</style>
